export const getDomainPart = (email: string) => {
  if (!email.includes("@")) throw new Error("Invalid email");
  return email.split("@").pop();
};
